// Dev-only sandbox to preview the Red Card error boundary fallback.
// Visit /__crash to trigger a render-time error. NOT linked from anywhere
// in the app; safe to leave shipped since it requires typing the URL.
function CrashSandbox() {
  // Intentional crash for QA / design preview
  throw new Error("Intentional crash from /__crash sandbox — used to preview the Red Card error boundary.");
}
export default CrashSandbox;
